(()=>{
 function init(scope=document){
  scope.querySelectorAll('form.db-search').forEach((form,index)=>{
   if(form.dataset.liveSearch)return;
   form.dataset.liveSearch='true';
   const input=form.querySelector('[name="q"]');
   if(!input)return;
   const panel=document.createElement('div');
   panel.className='db-live-results';panel.hidden=true;
   panel.id='db-live-search-'+Date.now()+'-'+index;
   panel.setAttribute('role','region');panel.setAttribute('aria-label',input.getAttribute('aria-label')||input.placeholder);
   panel.setAttribute('aria-live','polite');
   form.appendChild(panel);input.setAttribute('aria-controls',panel.id);input.setAttribute('aria-expanded','false');input.autocomplete='off';
   let timer,controller,revision=0,composing=false,last='';
   const hide=()=>{panel.hidden=true;input.setAttribute('aria-expanded','false');};
   const show=()=>{panel.hidden=false;input.setAttribute('aria-expanded','true');};
   const urlFor=query=>{const url=new URL(form.action,location.origin);url.search=new URLSearchParams(new FormData(form)).toString();url.searchParams.set('q',query);url.searchParams.set('type','product');const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);return url;};
   async function search(){
    clearTimeout(timer);if(composing)return;
    const query=input.value.trim();
    if(!query){revision++;controller?.abort();panel.replaceChildren();last='';hide();return;}
    if(query===last&&panel.childElementCount){show();return;}
    const request=++revision;controller?.abort();controller=new AbortController();
    panel.setAttribute('aria-busy','true');
    try{
     const url=urlFor(query);const response=await fetch(url,{signal:controller.signal});
     if(!response.ok)throw Error('Search failed');
     const doc=new DOMParser().parseFromString(await response.text(),'text/html');
     const listing=doc.querySelector('.db-listing');
     if(!listing)throw Error('Missing search results');
     if(request!==revision||input.value.trim()!==query)return;
     const content=listing.cloneNode(true);
     content.querySelectorAll('script').forEach(node=>node.remove());
     content.querySelectorAll('a').forEach(link=>{const target=new URL(link.getAttribute('href'),url);if(target.origin===location.origin){const preview=url.searchParams.get('preview_theme_id');if(preview)target.searchParams.set('preview_theme_id',preview);link.href=target.href;}});
     panel.replaceChildren(content);last=query;show();
    }catch(error){
     if(error.name==='AbortError'||request!==revision)return;
     const link=document.createElement('a');link.href=urlFor(query);link.textContent=(input.getAttribute('aria-label')||input.placeholder)+': '+query;
     panel.replaceChildren(link);show();
    }finally{if(request===revision)panel.removeAttribute('aria-busy');}
   }
   input.addEventListener('input',()=>{clearTimeout(timer);revision++;controller?.abort();last='';hide();if(!composing)timer=setTimeout(search,300);});
   input.addEventListener('compositionstart',()=>{composing=true;clearTimeout(timer);revision++;controller?.abort();});
   input.addEventListener('compositionend',()=>{composing=false;search();});
   input.addEventListener('blur',()=>{if(input.value.trim()!==last)search();});
   input.addEventListener('search',search);
   input.addEventListener('focus',()=>{if(input.value.trim()===last&&last)show();});
   form.addEventListener('keydown',event=>{if(event.key==='Escape'){clearTimeout(timer);revision++;controller?.abort();hide();}});
   form.addEventListener('submit',()=>{clearTimeout(timer);revision++;controller?.abort();});
   document.addEventListener('pointerdown',event=>{if(!form.contains(event.target)){clearTimeout(timer);revision++;controller?.abort();hide();}});
  });
 }
 init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
